<app-metric-dimension-name [showCategory]="showCategory"
                           [item]="agGridParams.componentParams.sourceGetter(agGridParams.row)"></app-metric-dimension-name>
